import React from "react";
import isEmpty from "lodash/isEmpty";

export class BulkAction extends React.Component {
  state = { selected: {}, isAllRecordsSelected: false };

  toggleBulkAction = () => {
    this.setState({ selected: {} });
  };

  isAnySelected = () => this.selectedItemsFromState().length >= 1;

  isAnySelectable = () => this.allSelectable().length >= 1;

  isItemSelectable = id => this.props.isItemSelectable(id);

  selectAllRecords = value => {
    this.setState({ isAllRecordsSelected: value });
  };

  allDisplayedRecordsAreSelected = () => {
    const selectedCount = this.selectedItemsFromState().length;
    const selectableCount = this.allSelectable().length;

    return selectedCount > 0 && selectedCount === selectableCount;
  };

  isItemSelected = id => this.state.selected[id] === true;

  allSelectable = () => this.props.items.filter(item => this.isItemSelectable(item));

  onCheck = id => {
    if (!this.isItemSelectable(id)) {
      return;
    }
    this.setState(prevState => ({
      selected: { ...prevState.selected, [id]: !prevState.selected[id] }
    }));
  };

  selectedItemsFromState = () => {
    const { selected } = this.state;
    const selectedItems = isEmpty(selected)
      ? []
      : Object.entries(selected).reduce((acc, [id, isSelected]) => (isSelected ? [...acc, id] : acc), []);
    return selectedItems;
  };

  toggleAll = () => {
    const { items } = this.props;
    const selectedCount = this.selectedItemsFromState().length;
    const selectableCount = this.allSelectable().length;
    if (selectedCount === selectableCount) {
      this.toggleBulkAction();
    } else {
      const pairs = items.map(item => [item, this.isItemSelectable(item)]);
      const selected = Object.fromEntries(pairs);
      this.setState(prevState => ({
        selected: { ...prevState.selected, ...selected }
      }));
    }
  };

  render() {
    const { isAllRecordsSelected } = this.state;
    const {
      toggleAll,
      onCheck,
      toggleBulkAction,
      isItemSelected,
      isAnySelected,
      isAnySelectable,
      selectedItemsFromState: getItems,
      selectAllRecords
    } = this;
    return this.props.children({
      toggleAll,
      onCheck,
      toggleBulkAction,
      isItemSelected,
      isAnySelected,
      isAnySelectable,
      getItems,
      allDisplayedRecordsAreSelected: this.allDisplayedRecordsAreSelected(),
      isAllRecordsSelected: isAllRecordsSelected,
      selectAllRecords: selectAllRecords
    });
  }
}
